module.exports = __webpack_public_path__ + "static/assets/664da05abbdb25fc499645258e587890.svg";